import { GridColDef } from '@mui/x-data-grid';
import Table from '../custom/Table';
import Title from '../custom/Title';
import DynamicForm from '../forms/DynamicForm';
import { INV_INVENTORY_FIELDS, INV_INVENTORY_SCONFIG } from '../../Models/Inventory';


export const Inventory = () => {

    const config = INV_INVENTORY_SCONFIG

    const getInventoryColumns = (): GridColDef<any>[] => {
        let minWidth = 100
        return INV_INVENTORY_FIELDS.map(inboundField => {
            switch (inboundField.id) {
                case "itemDescription":
                    minWidth = 130
                    break;
                case "productFineWt":
                    minWidth = 150
                    break;
                case "inventoryLocation":
                    minWidth = 150
                    break;
                case "qtyAvailableForSales":
                    minWidth = 160
                    break;
                case "qtyAvailableForTransfer":
                    minWidth = 180
                    break;
                case "qtyInTransitInbound":
                    minWidth = 160
                    break;
                case "qtyInTransitOutbound":
                    minWidth = 170
                    break;
                case "fineMetalBaseUnit":
                    minWidth = 160
                    break;
                case "netMetalBaseUnit":
                    minWidth = 160
                    break;
                case "openOrderQty":
                    minWidth = 120
                    break;
                default:
                    minWidth = 100
                    break;
            }

            return {
                field: inboundField.id,
                headerName: inboundField.label,
                minWidth
            }
        })
    }

    const InventoryRows = [{ id: 1 }]

    const submitHandler = (data: any): any => {
        console.log(data)
    }

    return (
        <div style={{ padding: '0 10px' }}>
            <div style={{ borderBottom: '1px solid #d8d8d8' }}>
                <Title style={{ textAlign: 'left', margin: '20px 10px 10px 10px', color: '#7f7d76' }}>Inventory On Hand Blotter</Title>
            </div>
            <div style={{ padding: '20px 0px' }}>
                <DynamicForm config={config} onSubmit={submitHandler} submitText='Search' onCancel={() => { }} cancelText='Clear Filter' />
            </div>
            <Table columns={getInventoryColumns()} rows={InventoryRows} />
        </div>
    )
}
